import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsComponent } from './notifications.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/external-components/angular-material.module';
import { SharedModule } from '../shared/shared.module';
import { FlexLayoutModule } from 'ng-flex-layout';
import { PipesModule } from 'src/app/pipes/pipes.module';

@NgModule({
  declarations: [NotificationsComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    /* Custom modules */
    AngularMaterialModule,
    SharedModule,
    PipesModule,

    /* Otros */
    FlexLayoutModule
  ],
  exports: [NotificationsComponent]
})
export class NotificationsModule { }
